// extracted by mini-css-extract-plugin
export var box = "_9c-1";
export var checkboxRow = "_9c-8";
export var checked = "_9c-2";
export var descriptionSpacer = "_9c-a";
export var disabled = "_9c-3";
export var icon = "_9c-6";
export var input = "_9c-0";
export var labelSpacer = "_9c-9";
export var medium = "_9c-5";
export var small = "_9c-4";
export var text = "_9c-7";